export class ApplicationVersion {
  static version = '4.16.0';
}
